export default "/images/vendor/flag-icon-css/flags/1x1/pg.svg?9ebf0bb36bfe656e7aba15d47451a236";